export default __webpack_public_path__ + "static/media/tickets_active.2a196d0a.svg";